module.exports = __webpack_public_path__ + "img/MCS_Logos.8daceab1.png";